<template>
  <li class="usermenu" style="position: relative">
    <div class="xgsat">
      <MobileOutlined style="font-size: 20px; color: var(--text-color)" />
      <span style="font-size: 14px; color: var(--text-color)">{{ $t('_app._xzbt') }}</span>
    </div>
    <div class="wrap-a1 popover popover-enter-to menubox gsdgt">
      <div class="sdgag">
        <div>
          <img src="../../assets/app_ios.png" class="asdt" />
        </div>
        <div>
          <img src="../../assets/app_android.png" class="asdt" />
        </div>
      </div>
      <div style="font-size: 14px; color: var(--text-color)">{{ $t('_app._xz') }}</div>
      <div class="sdtqe" style="font-size: 14px; color: var(--text-color)">{{ $t('_app._smerm') }}</div>
      <!-- <ul class="tab">
        <li class="active">{{ $t('_h._lsjl') }}</li>
      </ul> -->
      <!-- <ul class="list drama_list column">
        <li class="wrapbg1" @click="onService">
          <MobileOutlined style="margin-right: 13px; font-size: 20px" />
          <a-badge :count="chat_unread" :offset="[100, 5]">
            <div class="KCBwR lcFyR tuUGG RTmqg">{{ $t('_db._zsry') }}</div>
          </a-badge>
        </li>
        <li class="wrapbg1" v-if="sp_info.whatsapp">
          <IconWhatsApp style="margin-right: 13px; font-size: 20px" />
          <div>Whats app</div>
          <a :href="sp_info.whatsapp ? 'https://wa.me/' + sp_info.whatsapp : 'javascript:'" :target="sp_info.whatsapp ? '_blank' : ''"> </a>
        </li>
        <li class="wrapbg1" v-if="sp_info.telegram">
          <IconTelegram style="margin-right: 13px; font-size: 20px" />
          <div>Telegram</div>
          <a :href="sp_info.telegram ? 'https://t.me/' + sp_info.telegram : 'javascript:'" :target="sp_info.telegram ? '_blank' : ''"> </a>
        </li>
        <li class="wrapbg1" v-if="sp_info.line">
          <IconLine style="margin-right: 13px; font-size: 20px" />
          <div>Line</div>
          <a :href="sp_info.line" :target="sp_info.line ? '_blank' : ''"> </a>
        </li>
        <li class="wrapbg1" v-else-if="sp_info.line_qrcode" style="position: relative">
          <IconLine style="margin-right: 13px; font-size: 20px" />
          <div>Line</div>
          <div class="lineerwm">
            <img :src="sp_info.line_qrcode + '?r_qrcode=' + parseInt(Math.random() * 1000)" alt="line" style="width: 100%" />
          </div>
        </li>
      </ul> -->
      <!-- <button class="more" @click="onMoreHistofy()">{{ $t('_h._gd') }}</button> -->
    </div>
  </li>
</template>

<script>
import { MobileOutlined } from '@ant-design/icons-vue'
export default {
  name: 'serviceVue',
  components: { MobileOutlined },
  data() {
    return {}
  },
  created() {},
  methods: {}
}
</script>

<style>
.xgsat {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.asdt {
  width: 200px;
  height: 200px;
}

.sdgag {
  display: flex;
  gap: 10px;
}
.gsdgt {
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.sdtqe {
  color: #999;
  font-size: 14px;
}
</style>
